import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Drawer,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';

import FlowMoniVolumeCalibrationModule from './FlowMoniVolumeCalibrationModule';

const SensorDetailDrawer = ({
  sensor,
  open,
  onClose,
  unitData,
  isLoading,
  renderChart,
  handlePatchSensor,
  handleSupportClick,
}) => {
  const renderConnectionStatus = (lastRecorded) => {
    const dateNow = new Date();
    const dataLastRecorded = new Date(lastRecorded);

    let backGroundColor;

    if ((dateNow - dataLastRecorded) / 1000 < 3600) {
      backGroundColor = 'success.main';
    } else if ((dateNow - dataLastRecorded) / 1000 < 7200) {
      backGroundColor = 'warning.main';
    } else {
      backGroundColor = 'error.main';
    }
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: backGroundColor,
          }}
        />
      </Box>
    );
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
          padding: 3,
          width: '100%', // Ensures the Stack takes up the full width of the Drawer
          // minWidth: 600,
          // maxWidth: 1000, // Limits the width of the Drawer
          height: '100%', // Ensures the Stack takes up the full height of the Drawer
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            mb: 2,
          }}
        >
          <Box sx={{ display: 'flex' }}>
            {renderConnectionStatus(sensor?.DataLastRecorded)}
          </Box>
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', flexGrow: 1, ml: 1 }}
          >
            {sensor?.SensorType}
          </Typography>
          <IconButton
            size="small"
            onClick={onClose}
            sx={{ position: 'absolute', right: 0, borderRadius: 1, ml: 1 }}
          >
            <CloseIcon sx={{ color: 'gray' }} />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body1" fontSize="0.9rem" fontWeight="bold">
                Sensor ID
              </Typography>
              <Typography variant="body1" fontSize="0.9rem">
                {sensor?.SensorId}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant="body1" fontWeight="bold" fontSize="0.9rem">
                Calibration Type
              </Typography>
              <Typography variant="body1" fontSize="0.9rem">
                {sensor?.CalibrationType}
              </Typography>
            </Box>
          </Grid>

          {/* If SensorType == "FlowSomthing" then show below */}
          {sensor?.SensorType === 'FlowMoniVolume' ||
          sensor?.SensorType === 'FlowMoniEnergy' ? (
            <Grid item xs={12}>
              <FlowMoniVolumeCalibrationModule
                sensor={sensor}
                unitData={unitData}
                isLoading={isLoading}
                renderChart={renderChart}
                handlePatchSensor={handlePatchSensor}
                handleSupportClick={handleSupportClick}
              />
            </Grid>
          ) : null}
        </Grid>
      </Stack>
    </Drawer>
  );
};

export default SensorDetailDrawer;
